export default __webpack_public_path__ + "images/VZ.ae5ae37.png";